import { defineComponent } from 'vue';
const phpUnserialize = require('phpunserialize');
export default defineComponent({
    name: 'CatalogItem',
    events: ['add-to-cart', 'view-details', 'add-to-wishlist'],
    props: {
        host: {
            type: String,
            required: true,
        },
        lang: {
            type: String,
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
        showAddToCartBtn: {
            type: Boolean,
            default: true,
        },
        showQuantityInput: {
            type: Boolean,
            default: true,
        },
        schoolId: {
            type: Number,
        },
        roleId: {
            type: Number,
        }
    },
    data() {
        return {
            selectedId: this.product.id,
            quantity: 1,
        };
    },
    computed: {
        productLink() {
            switch (this.lang) {
                case 'it-IT':
                    return 'prodotto';
                default:
                    return 'prodotto';
            }
        },
        collection() {
            return this.product.taxonomies?.['product_collection']?.[0].name ?? '';
        },
        category() {
            if (this.product.taxonomies === undefined)
                return '';
            let cat = this.product.taxonomies?.['product_cat']?.[0];
            if (cat === undefined) {
                return '';
            }
            while (cat.children.length !== 0) {
                cat = cat.children[0];
            }
            return cat.name;
        },
        productType() {
            return this.product.taxonomies?.['product_type']?.[0].slug ?? '';
        },
        attributeList() {
            const list = this.product?.metadata?.['_attribute_list'] ?? undefined;
            if (list === undefined) {
                return undefined;
            }
            if (Array.isArray(list)) {
                return undefined;
            }
            return JSON.parse(list);
        },
        image() {
            return (this.product.image?.sizes['woocommerce_thumbnail']?.link ??
                this.product.image?.sizes['thumbnail']?.link ??
                this.product.image?.link ??
                this.host + '/wp-content/themes/montirussodigital/assets/images/placeholder.jpg');
        },
        sku() {
            const sku = this.product?.metadata?.['_sku'] ?? '';
            if (Array.isArray(sku)) {
                return '';
            }
            return sku.replace(/_$/, '');
        },
        onSale() {
            return this.price !== this.basePrice;
        },
        price() {
            //return this.taxPrice(this.product.price);
            if (this.schoolId && this.roleId) {
                const schoolPriceRaw = this.product.metadata?.['_mr_school'] ?? undefined;
                if (!schoolPriceRaw) {
                    return this.product.price;
                }
                const schoolPrice = phpUnserialize(schoolPriceRaw);
                const p = schoolPrice[this.schoolId]?.[this.roleId] ?? undefined;
                if (!p) {
                    return this.product.price;
                }
                const priceFormatter = new Intl.NumberFormat('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
                return priceFormatter.format(Number(p));
            }
            return this.product.price;
        },
        basePrice() {
            //return this.taxPrice(this.product.basePrice);
            return this.product.basePrice;
        },
        minPrice() {
            //return this.taxPrice(this.product.minPrice);
            return this.product.minPrice;
        },
        starRating() {
            return Number(this.product?.metadata?.['_wc_average_rating'] ?? '0');
        },
        hasStarRating() {
            return this.starRating > 0;
        },
        ratingStarClasses() {
            let classes = [];
            for (let i = 1; i <= 5; i++) {
                if (i <= this.starRating) {
                    classes.push('fas fa-star');
                }
                else if (i <= this.starRating + 0.5) {
                    classes.push('fas fa-star-half-alt');
                }
                else {
                    classes.push('far fa-star');
                }
            }
            return classes;
        },
        salePercentage() {
            if (this.onSale) {
                let reg = 0;
                let curr = 0;
                if (this.product.hasPriceRange) {
                    reg = Number(this.product.minBasePrice.replace(',', '.'));
                    curr = Number(this.product.minPrice.replace(',', '.'));
                }
                else {
                    reg = Number(this.basePrice.replace(',', '.'));
                    curr = Number(this.price.replace(',', '.'));
                }
                return Math.round(100 - (curr * 100) / reg).toString();
            }
            return '';
        },
        jvmWishListExists() {
            return typeof JVMWooCommerceWishlist === 'object';
        },
    },
    methods: {
        taxPrice(price) {
            let taxValue = 0;
            const tax = this.product?.metadata?.['_tax_class'] ?? '';
            if (tax.length === 0 || tax === 'Standard') {
                taxValue = 1.22;
            }
            else {
                taxValue = 1.1;
            }
            const priceTaxed = Number(price ?? 0) * Number(taxValue);
            return (Math.round(priceTaxed * 100) / 100).toFixed(2);
        },
        increaseQuantity(amount) {
            this.quantity += amount;
            if (this.quantity < 1) {
                this.quantity = 1;
            }
        },
    },
    mounted() {
        if (this.jvmWishListExists) {
            JVMWooCommerceWishlist.build();
        }
        if (this.productType === 'variable' && this.attributeList !== undefined) {
            for (const v of this.attributeList.variations) {
                if (v.stockStatus === 'instock') {
                    this.selectedId = v.variation.toString();
                    break;
                }
            }
        }
    },
});
